import { alphabeticalCompare } from '@cims-online/shared'
import { InternalOrConnectionOrder } from '../components/EditOrderModal/types'
import { Internal, Connection, Item, Query, WorkflowConnection } from './types'

export function internalOrConnection(
  item: Internal | Connection | WorkflowConnection
): InternalOrConnectionOrder {
  if (item.__typename === 'PayItemConnection')
    return { id: item.id, __typename: 'PayItemConnection' }
  if (item.__typename === 'WorkflowPayItemSummaryConnection')
    return {
      id: item.workflowId,
      __typename: 'WorkflowPayItemSummaryConnection',
    }
  return { id: item.internal.id, __typename: 'ProjectToInternalConnection' }
}

export function mergeWorkflowConnections(
  workflows: Query['workflows']['records'],
  connections: Query['workflowPayItemSummaryConnections']
): WorkflowConnection[] {
  return workflows.reduce<WorkflowConnection[]>((eligible, workflow) => {
    if (!workflow.fields.count) return eligible
    const connection = connections.find(
      ({ workflowId }) => workflowId === workflow.id
    ) ?? {
      __typename: 'WorkflowPayItemSummaryConnection' as const,
      groupId: null,
      order: 0,
      workflowId: workflow.id,
    }
    eligible.push({ ...connection, workflow })
    return eligible
  }, [])
}

export function sortByOrder(a: Item, b: Item) {
  const A = `${order(a)}${name(a)}`
  const B = `${order(b)}${name(b)}`
  return alphabeticalCompare(A, B)
}

function order({ order }: Item) {
  return order.toString().padStart(10, '0')
}

function name(item: Item) {
  if (item.__typename === 'ProjectToInternalConnection')
    return item.internal.classType
  else if (item.__typename === 'PayItemConnection')
    return item.name ?? item.googleSheet?.title ?? item.googleSheet?.compositeId
  else if (item.__typename === 'WorkflowPayItemSummaryConnection')
    return item.workflow.label
  return item.name
}
